import { render, staticRenderFns } from "./VaccineDosesForm.vue?vue&type=template&id=7a985ff1&"
import script from "./VaccineDosesForm.vue?vue&type=script&lang=js&"
export * from "./VaccineDosesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports